"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _moment = _interopRequireDefault(require("moment"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _ravenJs = _interopRequireDefault(require("raven-js"));
var _constants = require("../constants");
var _enums = require("../enums");
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var YES = _enums.COOKIE_PREFERENCE_OPTIONS.YES,
  NO = _enums.COOKIE_PREFERENCE_OPTIONS.NO;
var isValidPreferenceOption = function isValidPreferenceOption(preferenceOption) {
  return [NO, YES].includes(preferenceOption);
};
var writePreferencesCookie = function writePreferencesCookie(value) {
  var expires = (0, _moment["default"])().add(_constants.COOKIE_PREFERENCE_MAX_AGE, 'ms').toDate();
  _jsCookie["default"].set(_constants.COOKIE_PREFERENCE_NAME, value, {
    expires: expires
  });
};
var CookiePreference = (_class = /*#__PURE__*/function () {
  // Public
  function CookiePreference(_ref) {
    var _this = this;
    var appName = _ref.appName,
      enablePosthog = _ref.enablePosthog,
      disablePosthog = _ref.disablePosthog;
    _classCallCheck(this, CookiePreference);
    // State
    _defineProperty(this, "appName", undefined);
    _initializerDefineProperty(this, "cookiePreference", _descriptor, this);
    _initializerDefineProperty(this, "bannerIsDismissed", _descriptor2, this);
    _initializerDefineProperty(this, "showCookiePreferenceDialog", _descriptor3, this);
    _initializerDefineProperty(this, "savePreferenceButtonLoading", _descriptor4, this);
    _initializerDefineProperty(this, "acceptAllCookiesButtonLoading", _descriptor5, this);
    _initializerDefineProperty(this, "translations", _descriptor6, this);
    _initializerDefineProperty(this, "setAcceptAllCookiesButtonLoading", _descriptor7, this);
    _initializerDefineProperty(this, "setSavePreferenceButtonLoading", _descriptor8, this);
    _defineProperty(this, "setNotification", function (notification) {
      _this.notification = notification;
    });
    _initializerDefineProperty(this, "setTranslations", _descriptor9, this);
    _defineProperty(this, "updateCookiesFromCurrentPreferenceCookie", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(_this.currentCookieValue !== _constants.PRIVACY_POLICY_VERSION)) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return _this.disablePostHog(_this.appName);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _initializerDefineProperty(this, "acceptAllCookies", _descriptor10, this);
    _initializerDefineProperty(this, "setCookiePreferenceOption", _descriptor11, this);
    _initializerDefineProperty(this, "savePreferences", _descriptor12, this);
    _initializerDefineProperty(this, "openCookiePreferencesDialog", _descriptor13, this);
    _initializerDefineProperty(this, "hideCookiePreferencesDialog", _descriptor14, this);
    _initializerDefineProperty(this, "loadCookieData", _descriptor15, this);
    // Private
    _initializerDefineProperty(this, "hideBanner", _descriptor16, this);
    _initializerDefineProperty(this, "save", _descriptor17, this);
    this.appName = appName;
    this.enablePosthog = enablePosthog.bind(this);
    this.disablePostHog = disablePosthog.bind(this);
    (0, _mobx.makeObservable)(this);
  }
  return _createClass(CookiePreference, [{
    key: "currentCookieValue",
    get: function get() {
      return _jsCookie["default"].get(_constants.COOKIE_PREFERENCE_NAME);
    }
  }, {
    key: "showBanner",
    get: function get() {
      var preferenceCookieValue = this.currentCookieValue;
      var cookieHasValidValue = [NO, _constants.PRIVACY_POLICY_VERSION].includes(preferenceCookieValue);
      return !cookieHasValidValue && !this.bannerIsDismissed;
    }
  }]);
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cookiePreference", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return NO;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bannerIsDismissed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showCookiePreferenceDialog", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "savePreferenceButtonLoading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "acceptAllCookiesButtonLoading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "translations", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "setAcceptAllCookiesButtonLoading", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;
    return function (acceptAllCookiesButtonLoading) {
      return _this2.acceptAllCookiesButtonLoading = acceptAllCookiesButtonLoading;
    };
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "setSavePreferenceButtonLoading", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function (savePreferenceButtonLoading) {
      return _this3.savePreferenceButtonLoading = savePreferenceButtonLoading;
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "currentCookieValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentCookieValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showBanner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showBanner"), _class.prototype), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "setTranslations", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function (translations) {
      _this4.translations = translations;
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "acceptAllCookies", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;
    return /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(consentCookiesMutation) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this5.setCookiePreferenceOption(YES);
              _context2.next = 3;
              return _this5.save(consentCookiesMutation, _this5.setAcceptAllCookiesButtonLoading);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "setCookiePreferenceOption", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;
    return function (cookiePreference) {
      if (isValidPreferenceOption(cookiePreference)) {
        _this6.cookiePreference = cookiePreference;
        return true;
      } else {
        return false;
      }
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "savePreferences", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;
    return /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(consentCookiesMutation) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this7.save(consentCookiesMutation, _this7.setSavePreferenceButtonLoading);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }();
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "openCookiePreferencesDialog", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;
    return function () {
      _this8.loadCookieData();
      _this8.showCookiePreferenceDialog = true;
    };
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "hideCookiePreferencesDialog", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;
    return function () {
      _this9.showCookiePreferenceDialog = false;
    };
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "loadCookieData", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this10 = this;
    return function () {
      _this10.cookiePreference = _jsCookie["default"].get(_constants.COOKIE_PREFERENCE_NAME) === _constants.PRIVACY_POLICY_VERSION ? YES : NO;
      _this10.bannerIsDismissed = false;
    };
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "hideBanner", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this11 = this;
    return function () {
      _this11.bannerIsDismissed = true;
    };
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "save", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this12 = this;
    return /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(consentCookiesMutation, setLoading) {
        var _yield$consentCookies, data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              setLoading(true);
              if (!(_this12.cookiePreference === YES)) {
                _context4.next = 24;
                break;
              }
              _context4.prev = 2;
              _context4.next = 5;
              return consentCookiesMutation({
                version: _constants.PRIVACY_POLICY_VERSION
              });
            case 5:
              _yield$consentCookies = _context4.sent;
              data = _yield$consentCookies.data;
              if (!(data.consentCookies.result === true)) {
                _context4.next = 15;
                break;
              }
              writePreferencesCookie(_constants.PRIVACY_POLICY_VERSION);
              _context4.next = 11;
              return _this12.enablePosthog(_this12.appName);
            case 11:
              _this12.hideBanner();
              _this12.hideCookiePreferencesDialog();
              _context4.next = 16;
              break;
            case 15:
              throw new Error('Could not save preferences');
            case 16:
              _context4.next = 22;
              break;
            case 18:
              _context4.prev = 18;
              _context4.t0 = _context4["catch"](2);
              _ravenJs["default"].captureException(_context4.t0, {
                extra: {
                  version: _constants.PRIVACY_POLICY_VERSION
                }
              });
              _this12.notification.error(_this12.translations.couldntSavePreferences);
            case 22:
              _context4.next = 29;
              break;
            case 24:
              writePreferencesCookie(NO);
              _context4.next = 27;
              return _this12.disablePostHog(_this12.appName);
            case 27:
              _this12.hideBanner();
              _this12.hideCookiePreferencesDialog();
            case 29:
              setLoading(false);
            case 30:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[2, 18]]);
      }));
      return function (_x3, _x4) {
        return _ref5.apply(this, arguments);
      };
    }();
  }
})), _class);
var _default = exports["default"] = CookiePreference;
//# sourceMappingURL=cookie-preference.js.map